module.exports = __webpack_public_path__ + "img/ac1c5b32.png";